$(document).ready(function(){
	
	AOS.init({
  	offset: 60,
	});

});